import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

interface ForwardEmailApiResponse extends AxiosResponse {
  data: {
    apiStatus: string
    data: string
    time: string
  }
}

export interface ForwardEmailApiRequest extends Partial<AxiosRequestConfig> {
  data: {
    id: string
    to: string[]
    cc: string[]
    bookingNumber: string | null
    subject: string | null
    html: string | null
    attachmentBase64: null
  }
}

export function forwardEmailApi(
  { data, ...config }: ForwardEmailApiRequest,
  axiosInstance: AxiosInstance,
): Promise<ForwardEmailApiResponse> {
  return axiosInstance({
    method: "post",
    data,
    url: `newadmin/proxy-email-forward`,
    ...config,
  })
}
